import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { QueryVal, removeQuery } from 'Helpers/Query';
import { IconButton } from '@material-ui/core';
import Button from 'Components/UI/Button';
import CloseIcon from '@material-ui/icons/Close';
import MeetingSummaryTable from 'Components/UI/MeetingSummaryTable';
import DataContainer from 'Components/UI/DataContainer';
import { CustomLayout } from 'Components/UI/CustomLayout';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import tabRegistry from './tabRegistry';


const styles = theme => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
  },
  meetingTable: {
    flex: '1 0 0',
  },
  halfScreen: {
    maxHeight: '50vh',
    overflow: 'scroll',
  },
  tabContainer: {
    flex: '1 0 0',
  },
  content: {
    height: '100%',
    position: 'absolute',
  },
  unselectHousehold: {
    position: 'absolute',
    right: 0,
    zIndex: '100',
    padding: theme.spacing(1),
  },
  emailButtonContainer: {
    position: 'relative',
  },
  emailButton: {
    position: 'absolute',
    left: 0,
    zIndex: '100',
    padding: theme.spacing(1),
    marginLeft: theme.spacing(2),
    bottom: theme.spacing(2),
  },
});

const MeetingSummary = ({ className, classes }) => {
  const { householdResource } = useSimpleHousehold();
  const { userResource, agentResource } = useUserContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'Meeting Summary', isPageView: true });

  const filteredTabs = Object.entries(tabRegistry)
    .filter(([, tab]) => tab.hidden === undefined || !tab.hidden({ agentResource }));

  const filteredTabRegistry = Object.fromEntries(filteredTabs);
  const householdId = QueryVal('householdId');
  const meetingSummaryLink = QueryVal('meetingSummaryLink');

  const gmailComposeLink = `https://mail.google.com/mail/?authuser=${agentResource?.attr('email')}&fs=1&tf=cm&to=${householdResource?.attr('primaryClientEmail')}`;

  const onClickEmailButton = () => {
    logEvent('Clicked Email Client', {});
  };

  const onClickCloseButton = () => {
    removeQuery('householdId');
    logEvent('Clicked Close Button', {});
  };

  return (
    <Box
      className={classNames(classes.root, className)}
      {...rootNodeProps}
    >
      <div className={classNames(classes.meetingTable, {
        [classes.halfScreen]: householdId,
      })}
      >
        <MeetingSummaryTable />
      </div>
      {(meetingSummaryLink && householdId) && (
        <div>
          <div className={classes.emailButtonContainer}>
            <a href={gmailComposeLink} target="_blank" rel="noopener noreferrer" onClick={onClickEmailButton}>
              <Button color="primary" variant="contained" className={classes.emailButton}>
                {'Email Client'}
              </Button>
            </a>
          </div>
          <div className={classes.tabContainer}>
            <DataContainer
              className={classNames(classes.root, className)}
              householdResource={householdResource}
            >
              <IconButton className={classes.unselectHousehold} onClick={onClickCloseButton}>
                <CloseIcon />
              </IconButton>
              <CustomLayout
                className={classes.content}
                layoutLink={userResource?.relationship('meetingSummaryLayout').link('related')}
                tabRegistry={filteredTabRegistry}
                test="meeting-summary-custom-layout"
              />
            </DataContainer>
          </div>
        </div>
      )}
    </Box>
  );
};

MeetingSummary.defaultProps = {
  className: '',
};

MeetingSummary.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MeetingSummary);
